import {Box, IconButton, Tab, Tabs, Typography} from '@mui/material';
import './ViewTagsFolders.scss';
import ArrTooltipWrapper from '../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../assets/images/info-icon.svg';
import {t} from 'i18next';
import {useState} from 'react';
import {TabData, TabPanelProps} from '../user-management/edit-user/EditUser';
import TagsFoldersTabContent from './TagsFoldersTabContent';

function TabPanel(props: Readonly<TabPanelProps>) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={`tabpanel-${value === index ? 'active' : 'hidden'}`}
      {...other}
      data-testid={`view-tags-folders-tab-${index}`}
    >
      {value === index && (
        <div data-testid={`view-tags-folders-tab-child-${index}`}>
          {children}
        </div>
      )}
    </div>
  );
}

const shortInfo = () => (
  <>
    <p data-testid={`view-tags-folders-tt0`}>
      {t('tagsAndFolders.toolTip.tt0')}
    </p>
    <br data-testid={`view-tags-folders-br`} />
    <h3 data-testid={`view-tags-folders-tt1`}>
      {t('tagsAndFolders.toolTip.tt1')}
    </h3>
    <p data-testid={`view-tags-folders-tt2-tt3`}>
      {t('tagsAndFolders.toolTip.tt2')}
      <br data-testid={`view-tags-folders-br-btn`} />
      {t('tagsAndFolders.toolTip.tt3')}
    </p>
    <br data-testid={`view-tags-folders-br-button`} />
    <h3 data-testid={`view-tags-folders-tt4`}>
      {t('tagsAndFolders.toolTip.tt4')}
    </h3>
    <p data-testid={`view-tags-folders-tt5-tt6-tt7-tt8`}>
      {t('tagsAndFolders.toolTip.tt5')}

      <br data-testid={`view-tags-folders-br-icon`} />
      <br data-testid={`view-tags-folders-br-link`} />
      {t('tagsAndFolders.toolTip.tt6')}
      <br data-testid={`view-tags-folders-br-input`} />
      <br data-testid={`view-tags-folders-br-text`} />
      {t('tagsAndFolders.toolTip.tt7')}
      <br data-testid={`view-tags-folders-br-container`} />
      <br data-testid={`view-tags-folders-br-2`} />
      {t('tagsAndFolders.toolTip.tt8')}
    </p>
    <p data-testid={`view-tags-folders-tt9`}>
      {t('tagsAndFolders.toolTip.tt9')}
    </p>
  </>
);

const tabData: TabData[] = [
  {
    id: 'tags-tab',
    label: (
      <Typography
        className="typo-text subhead4_size tab-label"
        data-testid="tags-tab-label"
      >
        {t(`tagsAndFolders.tags`)}
      </Typography>
    ),
    content: <TagsFoldersTabContent type="tags" />,
  },
  {
    id: 'folders-tab',
    label: (
      <Typography
        className="typo-text subhead4_size tab-label"
        data-testid="folders-tab-label"
      >
        {t(`tagsAndFolders.folders`)}
      </Typography>
    ),
    content: <TagsFoldersTabContent type="folder" />,
  },
];

const ViewTagsFolders = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newTabValue: number
  ) => {
    setTabValue(newTabValue);
  };

  return (
    <Box
      className="view-tags-folders-main"
      role="region"
      aria-label={t('tagsAndFolders.title')}
    >
      <Box className="view-tags-folders-header">
        <Typography
          component="h1"
          id="tags-folders-page-title"
          className="typo-text headline3_size tags-folder-title-text"
          data-testid={`view-tags-folders-title`}
        >
          {t('tagsAndFolders.title')}
        </Typography>
        <ArrTooltipWrapper
          title={t('tagsAndFolders.title')}
          trigger={
            <IconButton
              size="small"
              className="tags-folder-info-icon"
              aria-label={t('tagsAndFolders.moreInfo')}
            >
              <InfoIcon
                fontSize="medium"
                className="tags-folder-info-icon"
                aria-hidden="true"
                focusable="false"
              />
            </IconButton>
          }
        >
          {shortInfo()}
        </ArrTooltipWrapper>
      </Box>
      <Tabs
        value={tabValue || 0}
        onChange={handleChangeTab}
        aria-label={t('tagsAndFolders.tabs')}
        className="tabs"
      >
        {tabData.map((tab) => (
          <Tab
            id={tab.id}
            aria-controls={`tabpanel-${tab.id}`}
            key={tab.id}
            label={tab.label}
            className="tab"
            data-testid={tab.id}
          />
        ))}
      </Tabs>
      {tabData.map((tab, index) => (
        <TabPanel key={tab.id} value={tabValue || 0} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
};

export default ViewTagsFolders;
